const hotspotIconCls = "_n29h1kvlmt7";
const containerCls = "_n29c1aklnc";

export { containerCls, hotspotIconCls };
import "./Hotspot.style.linaria.module.css";
//# sourceMappingURL=Hotspot.style.js.map
